import { motion, AnimatePresence } from "framer-motion";
import { mediaUrl } from "@/lib/api";
import { useSite } from "@/lib/site";
import { EASE } from "./Reveal";

export default function PhoneMockup({ shot, width = 270, delay = 0, caption = true, eager = false, crossfade = false }) {
  const { lang } = useSite();
  const src = shot?.media_id ? mediaUrl(shot.media_id) : null;
  const placeholder = lang === "fr" ? ["Capture de l'application", "(à ajouter)"] : ["لقطة من التطبيق", "(سيتم إضافتها)"];
  return (
    <motion.figure
      initial={{ opacity: 0, y: 44 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className="relative shrink-0 snap-center"
      style={{ width, maxWidth: "82vw" }}
      data-testid="phone-mockup"
    >
      <div className="relative rounded-[2.9rem] bg-[#0b0f0d] p-[10px] shadow-[0_40px_80px_-24px_rgba(8,33,26,0.6)] ring-1 ring-gold/25">
        <div className="absolute left-1/2 top-[16px] z-10 h-[20px] w-20 -translate-x-1/2 rounded-full bg-[#0b0f0d]" />
        <div className="relative overflow-hidden rounded-[2.35rem] bg-cream-deep" style={{ aspectRatio: "592/1280" }}>
          {src ? (
            crossfade ? (
              <AnimatePresence initial={false}>
                <motion.img
                  key={src}
                  src={src}
                  alt={shot?.title || "لقطة من تطبيق حلاق - 7ala9"}
                  loading={eager ? "eager" : "lazy"}
                  initial={{ opacity: 0, scale: 1.02 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.6, ease: EASE }}
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </AnimatePresence>
            ) : (
              <img
                src={src}
                alt={shot?.title || "لقطة من تطبيق حلاق - 7ala9"}
                loading={eager ? "eager" : "lazy"}
                className="h-full w-full object-cover"
              />
            )
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-cream-deep text-center text-xs leading-relaxed text-moss">
              {placeholder[0]}
              <br />
              {placeholder[1]}
            </div>
          )}
        </div>
        <div className="pointer-events-none absolute inset-0 rounded-[2.9rem] bg-gradient-to-tl from-white/10 via-transparent to-transparent" />
      </div>
      {caption && shot?.title && (
        <figcaption className="mt-4 text-center text-sm font-medium text-cream/80">{shot.title}</figcaption>
      )}
    </motion.figure>
  );
}
